(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-faq"] && !Shopify.designMode) return;
  try {
    
            $(document).on('click','.js_question',function(){
            let Height = $(this).next().children().outerHeight(true);
            $(this).toggleClass('is_active');
           let answerElem = $(this).next();
            if($(this).hasClass('is_active')){
                answerElem.stop().animate({
                    "height": Height +"px"
                },500);
            }else{
                answerElem.stop().animate({
                    "height": "0px"
                },500);
            }
            })
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-search-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.js_trigger').forEach((trigger, index) => {
    trigger.addEventListener('mouseenter', () => {
      document.querySelectorAll('.js_thumbnail').forEach((thumbnail) => thumbnail.classList.remove('is_active'));
      document.querySelectorAll('.js_thumbnail')[index]?.classList.add('is_active');
    });
  });

  document.querySelectorAll('.js_trigger04').forEach((trigger, index) => {
    trigger.addEventListener('mouseenter', () => {
      document.querySelectorAll('.js_thumbnail04').forEach((thumbnail) => thumbnail.classList.remove('is_active'));
      document.querySelectorAll('.js_thumbnail04')[index]?.classList.add('is_active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sissi-entry-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-sissi-entry]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    dialog.querySelector('[data-entry-choice="online"]')?.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.close();
    });

    dialog.querySelector('[data-sissi-entry-close]')?.addEventListener('click', () => {
      dialog.close();
    });

    dialog.querySelector('[data-entry-about]')?.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.close();
      const aboutSection = document.querySelector('#about');
      if (aboutSection) {
        window.history.pushState(null, '', '#about');
        aboutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    if (!Shopify.designMode) dialog.showModal();
    if (Shopify.designMode) dialog.setAttribute('open', '');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sissi-mobile-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-sissi-mobile-order]');
    if (!root) return;
    const storageKey = root.dataset.storageKey;
    const formatter = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 });
    let state;
    try {
      state = JSON.parse(localStorage.getItem(storageKey) || '{"items":[]}');
    } catch (error) {
      state = { items: [] };
      try { localStorage.removeItem(storageKey); } catch (storageError) {}
    }
    if (!state || typeof state !== 'object') state = { items: [] };
    if (!Array.isArray(state.items)) state.items = [];
    const itemsContainer = root.querySelector('[data-order-items]');
    const countElement = root.querySelector('[data-order-count]');
    const totalElement = root.querySelector('[data-order-total]');
    const checkoutButton = root.querySelector('[data-mobile-checkout]');
    const disabledReason = root.querySelector('[data-disabled-reason]');
    const statusElement = root.querySelector('[data-order-status]');
    const dateInput = root.querySelector('[data-pickup-date]');
    const dateTrigger = root.querySelector('[data-date-trigger]');
    const dateDisplay = root.querySelector('[data-date-display]');
    const datePicker = root.querySelector('[data-date-picker]');
    const calendarMonth = root.querySelector('[data-calendar-month]');
    const calendarDays = root.querySelector('[data-calendar-days]');
    const calendarPrev = root.querySelector('[data-calendar-prev]');
    const calendarNext = root.querySelector('[data-calendar-next]');
    const timeInput = root.querySelector('[data-pickup-time]');
    const nameInput = root.querySelector('[data-customer-name]');
    const phoneInput = root.querySelector('[data-customer-phone]');
    const websiteInput = root.querySelector('[data-order-website]');
    const orderSummary = root.querySelector('[data-order-summary]');
    const checkoutNote = root.querySelector('[data-checkout-note]');
    const successDialog = root.querySelector('[data-order-success]');
    const successOrderNumber = root.querySelector('[data-success-order-number]');

    const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[char]);
    const save = () => { try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) {} };
    const createOrderKey = () => {
      if (typeof window.crypto?.randomUUID === 'function') {
        try {
          return window.crypto.randomUUID();
        } catch (error) {
          console.warn('mobile_order_uuid_fallback', error);
        }
      }
      return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
    };
    const orderApiPath = String(root.dataset.orderApiUrl || '/apps/sissi-mobile-order/orders').trim();
    const orderApiUrl = /^https?:\/\//i.test(orderApiPath)
      ? orderApiPath
      : `${window.location.origin}${orderApiPath.startsWith('/') ? '' : '/'}${orderApiPath}`;
    const itemSignature = (item) => `${item.variantId}:${JSON.stringify(item.properties)}`;
    const yen = (minorUnits) => formatter.format(Number(minorUnits || 0) / 100);
    const fulfillment = () => 'pickup';
    const receiptKey = `${storageKey}-receipts-v1`;
    let receipts = [];
    let receiptSaved = true;
    let submitting = false;
    const validReceipt = (r) => r && typeof r.orderName === 'string' && typeof r.createdAt === 'number' &&
      r.createdAt > Date.now() - 60 * 86400000 && r.pickup && typeof r.pickup.date === 'string' &&
      typeof r.pickup.time === 'string' && typeof r.pickup.store === 'string' &&
      Number.isFinite(r.total) && r.total >= 0 && Array.isArray(r.items) && r.items.length > 0 &&
      r.items.every((i) => i && typeof i.title === 'string' && Number.isInteger(i.quantity) && i.quantity > 0);
    try {
      const stored = JSON.parse(localStorage.getItem(receiptKey) || '[]');
      if (Array.isArray(stored)) receipts = stored.filter(validReceipt).slice(0, 5);
    } catch (error) {}
    const receiptPanel = root.querySelector('[data-receipts]');
    const receiptList = root.querySelector('[data-receipt-list]');
    const renderReceipts = () => {
      receiptPanel.hidden = receipts.length === 0;
      receiptList.replaceChildren();
      receipts.forEach((receipt, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = `${receipt.orderName} · ${receipt.pickup.date} ${receipt.pickup.time}`;
        button.addEventListener('click', () => showReceipt(receipt, index > 0 || receiptSaved));
        receiptList.append(button);
      });
    };
    const showReceipt = (receipt, saved) => {
      successOrderNumber.textContent = receipt.orderName;
      root.querySelector('[data-receipt-date]').textContent = receipt.pickup.date;
      root.querySelector('[data-receipt-time]').textContent = receipt.pickup.time;
      root.querySelector('[data-receipt-store]').textContent = receipt.pickup.store;
      root.querySelector('[data-receipt-total]').textContent = yen(receipt.total);
      root.querySelector('[data-receipt-estimate]').hidden = receipt.exactTotal;
      root.querySelector('[data-receipt-storage]').textContent = saved ? root.dataset.receiptSavedLabel : root.dataset.receiptUnsavedLabel;
      const list = root.querySelector('[data-receipt-items]');
      list.replaceChildren();
      receipt.items.forEach((item) => {
        const row = document.createElement('li');
        const title = document.createElement('strong');
        title.textContent = `${item.title} × ${item.quantity}`;
        const variant = document.createElement('span');
        variant.textContent = item.variantTitle || '';
        row.append(title, variant);
        list.append(row);
      });
      if (!successDialog.open) successDialog.showModal();
      successDialog.querySelector('h2').focus();
    };
    renderReceipts();


    const renderSummary = () => {
      const method = fulfillment();
      const rows = [];
      rows.push(`<strong>${escapeHtml(root.dataset.summaryPickup)}</strong>`);
      rows.push(`<span>${escapeHtml(root.dataset.summaryStore)}：${escapeHtml(root.querySelector('.sissi-mo-order__store strong')?.textContent.trim() || '')}</span>`);
      if (dateInput.value) rows.push(`<span>${escapeHtml(root.dataset.summaryDate)}：${escapeHtml(dateInput.value)}</span>`);
      if (timeInput.value) rows.push(`<span>${escapeHtml(root.dataset.summaryTime)}：${escapeHtml(timeInput.value)}</span>`);
      orderSummary.innerHTML = rows.join('');
    };

    const render = () => {
      const totalQuantity = state.items.reduce((sum, item) => sum + item.quantity, 0);
      const total = state.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      countElement.textContent = totalQuantity;
      totalElement.textContent = yen(total);
      checkoutButton.disabled = state.items.length === 0;
      disabledReason.hidden = state.items.length > 0;
      renderSummary();

      if (!state.items.length) {
        itemsContainer.innerHTML = `<p class="sissi-mo-order__empty">${escapeHtml(itemsContainer.dataset.empty || '')}</p>`;
        return;
      }

      itemsContainer.innerHTML = state.items.map((item, index) => `
        <div class="sissi-mo-order-item">
          <img src="${escapeHtml(item.image)}" alt="" width="58" height="58" loading="lazy">
          <div>
            <strong>${escapeHtml(item.title)} × ${item.quantity}</strong>
            <span>${escapeHtml(item.variantTitle)}</span>
            <span>${yen(item.price * item.quantity)}</span>
          </div>
          <button type="button" data-remove-index="${index}" aria-label="${escapeHtml(root.dataset.removeLabel || '')}">×</button>
        </div>
      `).join('');
    };

    root.querySelectorAll('[data-open-product]').forEach((button) => {
      button.addEventListener('click', () => document.getElementById(button.dataset.openProduct)?.showModal());
    });
    root.querySelectorAll('[data-close-product]').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });
    root.querySelectorAll('[data-product-dialog]').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    root.querySelectorAll('[data-mobile-product-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const variantInput = form.querySelector('[name="variant"]');
        const variant = variantInput.matches('select') ? variantInput.selectedOptions[0] : variantInput;
        const item = {
          variantId: Number(data.get('variant').replace('gid://shopify/ProductVariant/', '')),
          title: form.dataset.productTitle,
          variantTitle: variant.dataset.title,
          image: form.dataset.productImage,
          price: Number(variant.dataset.price),
          quantity: Math.max(1, Math.min(10, Number(data.get('quantity') || 1))),
          isOmakase: form.dataset.productOmakase === 'true',
          properties: {
            '_注文区分': 'モバイルオーダー',
            '用途': data.get('occasion'),
            '年齢': data.get('recipient_age') || '',
            '性別': data.get('recipient_gender') || '',
            '仕上がり': variant.dataset.title,
            'ご要望': data.get('request') || '',
            '希望に対応できない場合': data.get('unavailable_action'),
            'おまかせ内容の了承': data.get('omakase_acknowledgement') || ''
          }
        };
        const existing = state.items.find((candidate) => itemSignature(candidate) === itemSignature(item));
        if (existing) existing.quantity = Math.min(10, existing.quantity + item.quantity);
        else state.items.push(item);
        state.orderKey = createOrderKey();
        save();
        render();
        form.closest('dialog')?.close();
        statusElement.textContent = '';
        document.querySelector('.sissi-mo-order')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    itemsContainer.addEventListener('click', (event) => {
      const button = event.target.closest('[data-remove-index]');
      if (!button) return;
      state.items.splice(Number(button.dataset.removeIndex), 1);
      state.orderKey = createOrderKey();
      save();
      render();
    });

    root.querySelectorAll('[data-mo-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-mo-filter]').forEach((candidate) => candidate.classList.toggle('is-active', candidate === button));
        root.querySelectorAll('[data-mo-product-card]').forEach((card) => {
          const filter = button.dataset.moFilter;
          const productType = card.dataset.productType;
          const productTitle = card.dataset.productTitle || '';
          const productPrice = Number(card.dataset.productPrice || 0);
          let matches = filter === 'all';
          if (filter === '花束' || filter === 'アレンジメント') matches = productType === filter;
          if (filter === 'omakase-bouquet') matches = card.dataset.productOmakase === 'true';
          if (filter === 'under-5500') matches = productPrice <= 550000;
          if (filter === '5501-10000') matches = productPrice > 550000 && productPrice <= 1000000;
          if (filter === 'over-10000') matches = productPrice > 1000000;
          card.hidden = !matches;
        });
      });
    });

    const tokyoFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' });
    const tokyoDate = (date) => {
      const parts = Object.fromEntries(tokyoFormatter.formatToParts(date).map((part) => [part.type, part.value]));
      return `${parts.year}-${parts.month}-${parts.day}`;
    };
    const addDays = (isoDate, days) => tokyoDate(new Date(new Date(`${isoDate}T12:00:00+09:00`).getTime() + days * 86400000));
    let now = new Date();
    let todayTokyo = tokyoDate(now);
    let leadDate = new Date(now.getTime() + Number(root.dataset.leadHours || 3) * 3600000);
    dateInput.max = addDays(todayTokyo, Number(root.dataset.maxDays || 60));
    let closedDays = (root.dataset.closedWeekdays || '').split(',').map((value) => value.trim()).filter((value) => /^[0-6]$/.test(value)).map(Number);
    let closedDates = [];
    let availabilityReady = false;
    const pickupSlotStarts = Array.from(timeInput.options).map((option) => {
      const match = option.value.match(/(\d{1,2}):(\d{2})/);
      return match ? `${String(match[1]).padStart(2, '0')}:${match[2]}` : null;
    }).filter(Boolean);
    const hasAvailablePickupSlot = (isoDate) => {
      const chosen = new Date(`${isoDate}T12:00:00+09:00`);
      if (closedDays.includes(chosen.getUTCDay()) || closedDates.includes(isoDate)) return false;
      if (isoDate !== todayTokyo) return pickupSlotStarts.length > 0;
      return pickupSlotStarts.some((time) => new Date(`${isoDate}T${time}:00+09:00`) >= leadDate);
    };
    let earliestPickupDate = todayTokyo;
    while (earliestPickupDate <= dateInput.max && !hasAvailablePickupSlot(earliestPickupDate)) {
      earliestPickupDate = addDays(earliestPickupDate, 1);
    }
    dateInput.min = earliestPickupDate;

    const isoMonth = (isoDate) => {
      const [year, month] = isoDate.split('-').map(Number);
      return new Date(Date.UTC(year, month - 1, 1));
    };
    const dateFromUtc = (date) => date.toISOString().slice(0, 10);
    let calendarCursor = isoMonth(dateInput.value || dateInput.min);
    const updateDateDisplay = () => {
      dateDisplay.textContent = dateInput.value ? dateInput.value.replaceAll('-', ' / ') : root.dataset.datePlaceholder;
    };
    const renderCalendar = () => {
      const year = calendarCursor.getUTCFullYear();
      const month = calendarCursor.getUTCMonth();
      calendarMonth.textContent = root.dataset.calendarMonthFormat.replace('__YEAR__', year).replace('__MONTH__', month + 1);
      const firstDay = calendarCursor.getUTCDay();
      const lastDate = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
      const parts = [];
      for (let index = 0; index < firstDay; index += 1) parts.push('<span class="sissi-mo-calendar__blank" aria-hidden="true"></span>');
      for (let day = 1; day <= lastDate; day += 1) {
        const iso = dateFromUtc(new Date(Date.UTC(year, month, day)));
        const disabled = !availabilityReady || iso < dateInput.min || iso > dateInput.max || !hasAvailablePickupSlot(iso);
        const classes = [iso === dateInput.value ? 'is-selected' : '', iso === todayTokyo ? 'is-today' : ''].filter(Boolean).join(' ');
        const dayLabel = root.dataset.calendarDayLabel.replace('__MONTH__', month + 1).replace('__DAY__', day);
        parts.push(`<button type="button" data-calendar-date="${iso}" class="${classes}" ${disabled ? 'disabled' : ''} aria-label="${escapeHtml(dayLabel)}">${day}</button>`);
      }
      calendarDays.innerHTML = parts.join('');
      const previousMonthEnd = dateFromUtc(new Date(Date.UTC(year, month, 0)));
      const nextMonthStart = dateFromUtc(new Date(Date.UTC(year, month + 1, 1)));
      calendarPrev.disabled = previousMonthEnd < dateInput.min;
      calendarNext.disabled = nextMonthStart > dateInput.max;
    };
    const closeCalendar = () => {
      datePicker.hidden = true;
      dateTrigger.setAttribute('aria-expanded', 'false');
    };
    const refreshAvailability = async () => {
      availabilityReady = false;
      const response = await fetch('/apps/sissi-mobile-order/pickup-settings', { cache: 'no-store' });
      const result = await response.json();
      if (!response.ok || !result.ok) throw new Error(root.dataset.errorNetwork);
      const settings = result.settings;
      closedDays = settings.closedWeekdays;
      closedDates = settings.closedDates;
      now = new Date();
      todayTokyo = tokyoDate(now);
      leadDate = new Date(now.getTime() + settings.leadHours * 3600000);
      dateInput.max = addDays(todayTokyo, settings.maxOrderDays);
      let earliest = todayTokyo;
      while (earliest <= dateInput.max && !hasAvailablePickupSlot(earliest)) earliest = addDays(earliest, 1);
      dateInput.min = earliest;
      availabilityReady = true;
      if (dateInput.value && (dateInput.value < dateInput.min || dateInput.value > dateInput.max || !hasAvailablePickupSlot(dateInput.value))) {
        dateInput.value = '';
        timeInput.value = '';
        statusElement.textContent = root.dataset.errorPickup;
      }
      validatePickupDate();
      updateDateDisplay();
      renderSummary();
    };
    const openCalendar = async () => {
      dateTrigger.disabled = true;
      try { await refreshAvailability(); }
      catch (error) { statusElement.textContent = root.dataset.errorNetwork; return; }
      finally { dateTrigger.disabled = false; }
      calendarCursor = isoMonth(dateInput.value || dateInput.min);
      renderCalendar();
      datePicker.hidden = false;
      dateTrigger.setAttribute('aria-expanded', 'true');
    };
    dateTrigger.addEventListener('click', () => datePicker.hidden ? openCalendar() : closeCalendar());
    calendarPrev.addEventListener('click', () => {
      calendarCursor = new Date(Date.UTC(calendarCursor.getUTCFullYear(), calendarCursor.getUTCMonth() - 1, 1));
      renderCalendar();
    });
    calendarNext.addEventListener('click', () => {
      calendarCursor = new Date(Date.UTC(calendarCursor.getUTCFullYear(), calendarCursor.getUTCMonth() + 1, 1));
      renderCalendar();
    });
    calendarDays.addEventListener('click', (event) => {
      const button = event.target.closest('[data-calendar-date]');
      if (!button || button.disabled) return;
      dateInput.value = button.dataset.calendarDate;
      dateInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateDateDisplay();
      closeCalendar();
      dateTrigger.focus();
    });
    document.addEventListener('click', (event) => {
      if (!datePicker.hidden && !event.target.closest('.sissi-mo-date-control')) closeCalendar();
    });
    dateTrigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCalendar();
    });
    updateDateDisplay();

    const validatePickupDate = () => {
      if (!dateInput.value) { dateInput.setCustomValidity(''); return; }
      const chosen = new Date(`${dateInput.value}T12:00:00+09:00`);
      if (closedDays.includes(chosen.getUTCDay()) || closedDates.includes(dateInput.value)) {
        dateInput.setCustomValidity(root.dataset.errorClosed);
        dateInput.reportValidity();
      } else {
        dateInput.setCustomValidity('');
      }

      const sameDay = dateInput.value === todayTokyo;
      Array.from(timeInput.options).forEach((option) => {
        if (!option.value) return;
        const match = option.value.match(/(\d{1,2}):(\d{2})/);
        if (!match || !sameDay) option.disabled = false;
        else {
          const slot = new Date(`${dateInput.value}T${String(match[1]).padStart(2, '0')}:${match[2]}:00+09:00`);
          option.disabled = slot < leadDate;
        }
      });
      if (timeInput.selectedOptions[0]?.disabled) timeInput.value = '';
    };
    refreshAvailability().catch(() => { statusElement.textContent = root.dataset.errorNetwork; });
    dateInput.addEventListener('change', () => { validatePickupDate(); renderSummary(); });
    timeInput.addEventListener('change', renderSummary);
    root.querySelector('[data-close-success]')?.addEventListener('click', () => successDialog?.close());

    checkoutButton.addEventListener('click', async () => {
      if (submitting) return;
      submitting = true;
      try {
      statusElement.textContent = '';
      const missingRequiredItemDetails = state.items.some((item) => !item.properties?.['希望に対応できない場合']);
      const missingGender = state.items.some((item) => !item.properties?.['性別']);
      const missingOmakaseAcknowledgement = state.items.some((item) => item.isOmakase && !item.properties?.['おまかせ内容の了承']);
      if (!state.items.length) {
        statusElement.textContent = root.dataset.errorEmpty;
        return;
      }
      if (missingRequiredItemDetails) {
        statusElement.textContent = root.dataset.errorRequired;
        return;
      }
      if (missingGender) {
        statusElement.textContent = root.dataset.errorGender;
        return;
      }
      if (missingOmakaseAcknowledgement) {
        statusElement.textContent = root.dataset.errorOmakaseAcknowledgement;
        return;
      }
      try { await refreshAvailability(); }
      catch (error) { statusElement.textContent = root.dataset.errorNetwork; return; }
      if (!dateInput.value || !timeInput.value) {
        statusElement.textContent = root.dataset.errorPickup;
        return;
      }
      if (!dateInput.checkValidity()) {
        dateInput.reportValidity();
        return;
      }
      if (!nameInput.value.trim()) {
        nameInput.setCustomValidity(root.dataset.errorName);
        nameInput.reportValidity();
        return;
      }
      nameInput.setCustomValidity('');
      const phoneDigits = phoneInput.value.replace(/\D/g, '');
      if (phoneDigits.length < 10 || phoneDigits.length > 11) {
        phoneInput.setCustomValidity(root.dataset.errorPhone);
        phoneInput.reportValidity();
        return;
      }
      phoneInput.setCustomValidity('');
      const customerPhone = phoneDigits.startsWith('81')
        ? `+${phoneDigits}`
        : phoneDigits.startsWith('0')
          ? `+81${phoneDigits.slice(1)}`
          : `+81${phoneDigits}`;
      checkoutButton.disabled = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      const checkoutLabel = checkoutButton.querySelector('span');
      const originalLabel = checkoutLabel.textContent;
      checkoutLabel.textContent = root.dataset.submittingLabel;
      try {
        if (!state.orderKey) state.orderKey = createOrderKey();
        save();
        const storeName = root.querySelector('.sissi-mo-order__store strong')?.textContent.trim() || '';
        const order = {
          idempotencyKey: state.orderKey,
          submittedAt: Date.now(),
          website: websiteInput.value,
          customer: { name: nameInput.value.trim(), phone: customerPhone },
          pickup: { date: dateInput.value, time: timeInput.value, store: storeName },
          items: state.items.map((item) => ({
            variantId: String(item.variantId),
            title: item.title,
            quantity: item.quantity,
            properties: item.properties
          }))
        };
        const receiptItems = state.items.map((item) => ({ title: item.title, variantTitle: item.variantTitle || '', quantity: item.quantity }));
        const estimatedTotal = state.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const response = await fetch(orderApiUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(order)
        });
        const responseText = await response.text();
        let payload = {};
        try {
          payload = responseText ? JSON.parse(responseText) : {};
        } catch (error) {
          throw new Error(root.dataset.errorNetwork);
        }
        if (!response.ok || !payload.ok || !payload.orderName) {
          throw new Error(payload.error || root.dataset.errorNetwork);
        }
        const amount = payload.total?.amount;
        const exactTotal = amount !== null && amount !== undefined && amount !== '' &&
          payload.total?.currencyCode === 'JPY' && Number.isFinite(Number(amount)) && Number(amount) >= 0;
        const receipt = {
          orderName: payload.orderName,
          createdAt: Date.now(),
          pickup: payload.pickup || order.pickup,
          items: receiptItems,
          total: exactTotal ? Math.round(Number(amount) * 100) : estimatedTotal,
          exactTotal
        };
        receipts = [receipt, ...receipts.filter((r) => r.orderName !== receipt.orderName)].slice(0, 5);
        try { localStorage.setItem(receiptKey, JSON.stringify(receipts)); receiptSaved = true; }
        catch (error) { receiptSaved = false; }
        state = { items: [], orderKey: createOrderKey() };
        save();
        showReceipt(receipt, receiptSaved);
        renderReceipts();
        render();
      } catch (error) {
        console.error('mobile_order_submit_failed', error);
        statusElement.textContent = error instanceof Error && error.message ? error.message : root.dataset.errorNetwork;
      } finally {
        checkoutButton.disabled = state.items.length === 0;
        checkoutButton.removeAttribute('aria-busy');
        checkoutLabel.textContent = originalLabel;
      }
      } finally { submitting = false; }
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
